import { FocusMonitor } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Optional,
  Self,
  ViewChild,
} from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';

import intlTelInput from 'intl-tel-input';

import { BaseMatControlComponent } from '../forms/base-mat-control.component';

@Component({
  selector: 'app-easy-phone-subform',
  templateUrl: './easy-phone-subform.component.html',
  styleUrls: ['./easy-phone-subform.component.scss'],
  providers: [
    { provide: MatFormFieldControl, useExisting: EasyPhoneSubformComponent },
  ],
})
export class EasyPhoneSubformComponent
  extends BaseMatControlComponent<string>
  implements AfterViewInit
{
  @Input() basicPhone?: string;
  @Input() hint = '';
  DEFAULT_COUNTRY = 'hu';
  PREFERRED_COUNTRIES = ['hu'];

  @ViewChild('phone', { static: true }) inputElement!: ElementRef;

  constructor(
    @Optional() @Self() public override ngControl: NgControl,
    protected override formBuilder: FormBuilder,
    protected override focusMonitor: FocusMonitor,
    protected override elRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {
    super(ngControl, formBuilder, focusMonitor, elRef);
    this.controlIdentity = 'easy-input';
    this.controlType = 'input';
  }

  ngAfterViewInit(): void {
    // initialize International Telephone Input
    intlTelInput(this.inputElement.nativeElement, {
      initialCountry: this.DEFAULT_COUNTRY,
      preferredCountries: this.PREFERRED_COUNTRIES,
      nationalMode: false,
      autoHideDialCode: false,
    });
    this.cdr.detectChanges();
  }

  useBasicDataPhone(phone?: string) {
    if (phone) {
      this.value = phone;
    } else {
      this.value = '';
    }
  }

  disablePhoneInputTrigger(checked: boolean) {
    checked
      ? this.formParent.controls['phone'].disable()
      : this.formParent.controls['phone'].enable();
  }
}
